import { Box, Typography } from "@mui/material";
import { PROJECT_ACCENT_VAR } from "@/components/project/ProjectThemeProvider";

interface GalleryHeaderProps {
  title?: string | null;
  projectName: string;
  projectLogoUrl?: string | null;
}

export default function GalleryHeader({
  title,
  projectName,
  projectLogoUrl,
}: GalleryHeaderProps) {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: { xs: 2, sm: 3 },
        py: 1.5,
        bgcolor: "rgba(0, 0, 0, 0.6)",
        backdropFilter: "blur(8px)",
        borderBottom: `2px solid var(${PROJECT_ACCENT_VAR}, #3b82f6)`,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        {projectLogoUrl && (
          <Box
            component="img"
            loading="lazy"
            src={projectLogoUrl}
            alt={projectName}
            sx={{
              height: { xs: 28, sm: 36 },
              maxWidth: { xs: 80, sm: 120 },
              objectFit: "contain",
            }}
          />
        )}
        <Typography variant="subtitle1" sx={{ color: "#fff", fontWeight: 600 }}>
          {projectName}
        </Typography>
      </Box>
      {title && (
        <Typography variant="subtitle1" sx={{ color: "rgba(255,255,255,0.9)" }}>
          {title}
        </Typography>
      )}
    </Box>
  );
}
